import { useContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import "../../style.css";
import { ChartBar } from "./chart";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export interface Documents {
  data: {
    collects: {
      status: string;
      region: string;
      qtd: number;
    }[]
  };
}

export const ChartRegionCollectsDocuments = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { shortToken , id, mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);
  let routeDocuments: string;
  const [documents, setDocuments] = useState<Documents["data"]>({
    collects: [{ status: "", region: "", qtd: 0 }]
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeDocuments = `/documents/collects?graphic_id=chartRegionCollectsDocuments&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeDocuments = `/documents/collects?graphic_id=chartRegionCollectsDocuments&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();

    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    api
      .get(routeDocuments)
      .then((documents: Documents) => {
        setDocuments(documents.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return (
    <>
      {useMemo(() => {
        return (
          <>
            <div id="chart-region-collects-documents" className="h100 w100">
              {completeRequisition ? (
                <ChartBar data={documents} />
              ) : (
                <LoadingGraphics />
              )}
            </div>
          </>
        );
      }, [completeRequisition, documents])}
    </>
  );
};
